import { Box, TablePagination } from '@mui/material'

interface TableToolbarProps {
  readonly page: number
  readonly rowsPerPage: number
  readonly totalCount: number
  readonly onChangePage: (event: unknown, newPage: number) => void
  readonly onChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
  readonly rowsPerPageOptions?: number[]
}

const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50]

export function TableToolbar({
  page,
  rowsPerPage,
  totalCount,
  onChangePage,
  onChangeRowsPerPage,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
}: TableToolbarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={onChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onChangeRowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        showFirstButton
        showLastButton
      />
    </Box>
  )
}
